import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import {
    FiDownload,
    FiRefreshCw,
    FiImage,
    FiChevronLeft,
    FiChevronRight
} from "react-icons/fi";
import { RiDrawLine } from "react-icons/ri";

import StepHeader from "../common/StepHeader";
import PrimaryButton from "../common/PrimaryButton";
import LoadingSpinner from "../common/LoadingSpinner";

import "./GeneratedImage.css";
import AiFactsDisplay from "../../../../Components/AiFacts/AiFactsDisplay";
import ImageDrawer from "./ImageDrawer";

const GeneratedImage = ({
    image,
    loading,
    onDownload,
    onRegenerate,
    editImagePreview,
    onImageChange,
    onRemoveImage,
    onDrawnImage,
    drawnImagePreview,
    onRemoveDrawnImage,
    onAudit,
    isAuditing,
    isPublishable,
    history,
    onSelect
}) => {

    const [selectedImage, setSelectedImage] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false);

    // Swipe and Navigation logic
    const currentIndex = history?.findIndex(item => item.imageUrl === image) ?? -1;
    const lightboxIndex = selectedImage ? history?.findIndex(item => item.imageUrl === selectedImage) ?? -1 : -1;

    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };
    
    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };
    
    const onTouchEnd = (isLightbox = false) => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        
        const cIndex = isLightbox ? lightboxIndex : currentIndex;
        
        if (isLeftSwipe) { // next image
            if (cIndex !== -1 && cIndex < history.length - 1) {
                const nextImg = history[cIndex + 1].imageUrl;
                onSelect(nextImg);
                if (isLightbox) setSelectedImage(nextImg);
            }
        }
        if (isRightSwipe) { // prev image
            if (cIndex > 0) {
                const prevImg = history[cIndex - 1].imageUrl;
                onSelect(prevImg);
                if (isLightbox) setSelectedImage(prevImg);
            }
        }
    };

    const handlePrev = React.useCallback((e, isLightbox = false) => {
        if (e) e.stopPropagation();
        const cIndex = isLightbox ? lightboxIndex : currentIndex;
        if (cIndex > 0) {
            const prevImg = history[cIndex - 1].imageUrl;
            onSelect(prevImg);
            if (isLightbox) setSelectedImage(prevImg);
        }
    }, [currentIndex, lightboxIndex, history, onSelect]);

    const handleNext = React.useCallback((e, isLightbox = false) => {
        if (e) e.stopPropagation();
        const cIndex = isLightbox ? lightboxIndex : currentIndex;
        if (cIndex !== -1 && cIndex < history.length - 1) {
            const nextImg = history[cIndex + 1].imageUrl;
            onSelect(nextImg);
            if (isLightbox) setSelectedImage(nextImg);
        }
    }, [currentIndex, lightboxIndex, history, onSelect]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!selectedImage) return;
            if (e.key === "ArrowLeft") {
                handlePrev(null, true);
            } else if (e.key === "ArrowRight") {
                handleNext(null, true);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [handleNext, handlePrev, selectedImage]);

    return (

        <div className="generated-card">

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <StepHeader
                    number={2}
                    title="Perfect"
                />

                <div className="generated-buttons">

                    <PrimaryButton
                        onClick={onDownload}
                        disabled={!image || loading}
                        variant={!image || loading ? "secondary" : "primary"}
                    >
                        <FiDownload />
                    </PrimaryButton>

                    <PrimaryButton
                        onClick={onRegenerate}
                        disabled={!image || loading}
                        variant={!image || loading ? "secondary" : "primary"}
                    >
                        <FiRefreshCw />
                    </PrimaryButton>



                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                <p style={{ color: "white", margin: "2px 2px" }}>Workspace</p>
                {history && history.length > 0 && (
                    <select
                        value={image || ""}
                        onChange={(e) => onSelect(e.target.value)}
                        disabled={loading}
                        style={{
                            backgroundColor: "#4f46e5",
                            color: "white",
                            WebkitTextFillColor: "white",
                            border: "1px solid #333",
                            borderRadius: "5px",
                            padding: "4px 8px",
                            outline: "none",
                            fontSize: "12px",
                            cursor: "pointer"
                        }}
                    >
                        {history.map((item) => (
                            <option
                                key={item.version}
                                value={item.imageUrl}
                                style={{ color: "white", backgroundColor: "#4f46e5" }}
                            >
                                Version {item.version}
                            </option>
                        ))}
                    </select>
                )}
            </div>

            <div className="generated-preview">

                {loading ? (

                    <div className="loading-box">
                        <LoadingSpinner
                            text="Generating your image...!"
                        />

                        <AiFactsDisplay />

                        <p
                        style={{
                            fontSize: "12px",
                            color: "GrayText",
                            textAlign: "center"
                        }}
                        >Some image generations may be blocked to ensure responsible and safe AI use.</p>
                    </div>

                ) : drawnImagePreview ? (

                    <div style={{ 
                        // position: "relative", 
                        width: "100%", 
                        height: "100%", 
                        display: "inline-block" 
                        // display: "flex"
                        }}>
                        <img
                            src={drawnImagePreview}
                            alt="Drawn"
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedImage(drawnImagePreview);
                            }}
                            className="generated-image"
                        />
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (onRemoveDrawnImage) onRemoveDrawnImage();
                            }}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "rgba(0,0,0,0.6)",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "16px",
                                zIndex: 10
                            }}
                            title="Undo Drawing"
                        >
                            ✕
                        </button>
                    </div>

                ) : image ? (

                    <div 
                        style={{ 
                            // position: "relative",
                             width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={() => onTouchEnd(false)}
                    >
                        {history && history.length > 1 && currentIndex > 0 && (
                            <button 
                                onClick={(e) => handlePrev(e, false)}
                                style={{ position: "absolute", left: "10px", zIndex: 5, background: "rgba(0,0,0,0.6)", color: "white", border: "none", borderRadius: "50%", width: "36px", height: "36px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                <FiChevronLeft size={24} />
                            </button>
                        )}
                        <img
                            src={image}
                            alt="Generated"
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedImage(image);
                            }}
                            className="generated-image"
                        />
                        {history && history.length > 1 && currentIndex !== -1 && currentIndex < history.length - 1 && (
                            <button 
                                onClick={(e) => handleNext(e, false)}
                                style={{ position: "absolute", right: "10px", zIndex: 5, background: "rgba(0,0,0,0.6)", color: "white", border: "none", borderRadius: "50%", width: "36px", height: "36px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                <FiChevronRight size={24} />
                            </button>
                        )}
                    </div>

                ) : (

                    <div className="generated-placeholder">

                        <FiImage />

                        <h4>

                            Your generated image will appear here

                        </h4>

                        <p>

                            You can regenerate it by clicking the Generate icon.

                        </p>

                    </div>

                )}

            </div>

            {image && <div className="generated-footer">
                <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "space-between", width: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <PrimaryButton style={{ width: "40px", height: "40px" }} onClick={() => setIsDrawing(true)} disabled={loading || isAuditing}>
                            <RiDrawLine style={{ fontSize: "30px" }} />
                        </PrimaryButton>
                        <p style={{ marginTop: "10px", fontSize: "12px", color: "gray" }}>Click the Draw icon, mark any area, and tell the AI what to add, remove, or change.</p>
                    </div>
                    <PrimaryButton style={{ height: "40px", padding: "0 15px" }} onClick={onAudit} disabled={isAuditing || isPublishable || loading}>
                        {isAuditing ? <Spinner animation="border" size="sm" /> : "Audit"}
                    </PrimaryButton>
                </div>
            </div>}

            {selectedImage && (
                <div
                    className="generated-lightbox"
                    onClick={() => setSelectedImage(null)}
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={() => onTouchEnd(true)}
                >

                    {history && history.length > 1 && lightboxIndex > 0 && (
                        <button
                            onClick={(e) => handlePrev(e, true)}
                            style={{ position: "absolute", left: "20px", zIndex: 1005, background: "rgba(0,0,0,0.6)", color: "white", border: "none", borderRadius: "50%", width: "50px", height: "50px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                            <FiChevronLeft size={36} />
                        </button>
                    )}

                    <img
                        src={selectedImage}
                        alt="Preview"
                        className="generated-lightbox-image"
                        onClick={(e) => e.stopPropagation()}
                    />

                    {history && history.length > 1 && lightboxIndex !== -1 && lightboxIndex < history.length - 1 && (
                        <button
                            onClick={(e) => handleNext(e, true)}
                            style={{ position: "absolute", right: "20px", zIndex: 1005, background: "rgba(0,0,0,0.6)", color: "white", border: "none", borderRadius: "50%", width: "50px", height: "50px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                            <FiChevronRight size={36} />
                        </button>
                    )}

                    <button
                        className="generated-lightbox-close"
                        onClick={() => setSelectedImage(null)}
                    >
                        ✕
                    </button>

                </div>
            )}

            {isDrawing && image && (
                <ImageDrawer
                    imageUrl={drawnImagePreview || image}
                    onClose={() => setIsDrawing(false)}
                    onSave={(file, previewUrl) => {
                        if (onDrawnImage) {
                            onDrawnImage(file, previewUrl);
                        }
                        setIsDrawing(false);
                    }}
                />
            )}

        </div>


    );

};

export default GeneratedImage;